import Currency from "./Currecny/index";
import DocType from "./DocType/index";
import AccountSetting from './AccountSetting'
import PrintCustomiaztion from './Print'
export default {
  PrintCustomiaztion,
  AccountSetting,
  
  Currency,
  DocType,
};